import { render } from "./cart.vue?vue&type=template&id=5976a52e&scoped=true"
import script from "./cart.vue?vue&type=script&lang=js"
export * from "./cart.vue?vue&type=script&lang=js"

import "./cart.vue?vue&type=style&index=0&id=5976a52e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5976a52e"]])

export default __exports__